export class OrderOptionsRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing order setup request");
        }
        if (!request.id) {
            throw new Error("Missing vehicle ID in order setup request");
        }
    }
    forVehicle(id) {
        this.properties.id = id;
        return this;
    }
    forDealer(id) {
        this.properties.branchId = id;
        return this;
    }
    build() {
        return this.properties;
    }
}
